import { Cross2Icon, UploadIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { store } from "../../services/service";

export const UploadButton = ({ title, uploadUrl, fetchData, model }) => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [message, setMessage] = useState("");
  const [fichier, setFichier] = useState([]);

  const handleChangeFichier = (e) => {
    const selectedFiles = e.target.files;
    const newFiles = Array.from(selectedFiles);
    setFichier((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleUpload = () => {
    setIsSubmit(true);
    store(uploadUrl, "multipart/form-data", {
      fichier: fichier[0],
    })
      .then((res) => {
        if (res.status === 200) {
          setIsSubmit(null);
          fetchData();
          document.getElementById("upload").close();
          toast.success("Fichier chargé avec succès");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setMessage(err?.response?.data?.donnee);
      });
  };

  return (
    <div>
      <button
        onClick={() => document.getElementById("upload").showModal()}
        className="btn btn-sm bg-black text-white"
      >
        {title || "Charger un fichier"}
      </button>

      <dialog id="upload1" className="modal rounded-none">
        <div className="modal-box w-10/12 max-w-xl">
          <div className="modal-action">
            <h1 className="font-mtn mr-auto text-2xl font-bold">
              Charger un fichier
            </h1>
            <form method="dialog">
              <button id="close_upload" className="btn btn-sm">
                <Cross2Icon />
              </button>
            </form>
          </div>
          <div>
            <p className="text-xs text-red-600">{message}</p>
            <label className="form-contro w-full">
              <div className="label flex flex-col justify-start items-start gap-1.5">
                <span className="label-text  font-medium text-gray-400"></span>
                <div className="w-full">
                  <div className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm ">
                    <div className="flex justify-center mb-3">
                      <UploadIcon />
                    </div>

                    <p className="text-center text-sm">
                      {fichier.length !== 0 ? "" : "Charger le fichier"}
                    </p>
                    <div className="flex justify-center">
                      <input
                        className="text-sm mx-auto file-input-bordered mb-3 file-input file-input-ghost w-full max-w-xs"
                        type="file"
                        id="fichier"
                        onChange={handleChangeFichier}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </label>
            {model && (
              <a
                href={model}
                download="modelFichier"
                className="btn text-white bg-black btn-sm mx-1"
              >
                Telecharger le model
              </a>
            )}
            <button
              onClick={handleUpload}
              disabled={isSubmit ? true : fichier.length === 0 ? true : false}
              className="font-mtn bg-main btn btn-sm"
            >
              charger le fichier
            </button>
          </div>
        </div>
      </dialog>

      <dialog id="upload" className="modal rounded-none backdrop-blur-sm">
        <div className="modal-box p-0 bg-white rounded-2xl shadow-2xl border-0 lg:max-w-md">
          {/* En-tête avec gradient */}
          <div className="bg-gradient-to-r from-black to-black px-6 py-4 rounded-t-2xl">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                  <UploadIcon className="w-5 h-5 text-white" />
                </div>
                <h1 className="font-bold text-lg font-mtn text-white">
                  Charger un fichier
                </h1>
              </div>
              <form method="dialog">
                <button
                  onClick={() => setFichier([])}
                  id="close_upload"
                  className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors duration-200"
                >
                  <Cross2Icon className="w-4 h-4 text-white" />
                </button>
              </form>
            </div>
          </div>

          <div className="p-3 space-y-3">
            {message && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-red-600 text-xs font-bold">!</span>
                  </div>
                  <p className="text-red-700 text-sm font-medium">{message}</p>
                </div>
              </div>
            )}

            <div className="relative">
              <div
                className={`
            relative border-2 border-dashed rounded-xl transition-all duration-200
            ${
              fichier.length !== 0
                ? "border-green-300 bg-green-50"
                : "border-gray-300 bg-gray-50 hover:border-blue-400 hover:bg-blue-50"
            }
          `}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.add(
                    "border-blue-400",
                    "bg-blue-50"
                  );
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  if (fichier.length === 0) {
                    e.currentTarget.classList.remove(
                      "border-blue-400",
                      "bg-blue-50"
                    );
                  }
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.remove(
                    "border-blue-400",
                    "bg-blue-50"
                  );
                  const files = Array.from(e.dataTransfer.files);
                  if (files.length > 0) {
                    handleChangeFichier({ target: { files } });
                  }
                }}
              >
                <div className="text-center py-2">
                  <input
                    className="hidden inset-0 w-full h-full"
                    type="file"
                    id="fichier"
                    onChange={handleChangeFichier}
                  />
                  {fichier.length === 0 ? (
                    <>
                      {/* Icône animée */}
                      <div className="mx-auto w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-200">
                        <UploadIcon className="w-8 h-8 text-black" />
                      </div>

                      {/* Texte principal */}
                      <h3 className="text-sm font-semibold text-gray-900">
                        Glissez-déposez votre fichier ici
                      </h3>
                      <p className="text-sm text-gray-500">
                        ou cliquez pour parcourir vos fichiers
                      </p>

                      {/* Input file stylé */}
                      <div className="inline-block py-2">
                        <button
                          onClick={() =>
                            document.getElementById("fichier").click()
                          }
                          type="button"
                          className="bg-main text-black px-6 py-2.5 rounded-lg font-medium text-sm"
                        >
                          Parcourir les fichiers
                        </button>
                      </div>

                      {/* Formats acceptés */}
                      <p className="text-xs text-gray-400 mt-4">
                        Formats supportés: XLS, XLSX
                      </p>
                    </>
                  ) : (
                    <>
                      {/* Fichier sélectionné */}
                      <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                        <svg
                          className="w-8 h-8 text-green-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>

                      <h3 className="text-lg font-semibold text-green-800 mb-2">
                        Fichier sélectionné
                      </h3>
                      <p className="text-sm text-green-600 font-medium mb-4">
                        {fichier[0]?.name}
                      </p>
                      <p className="text-xs text-gray-500">
                        Taille: {(fichier[0]?.size / 1024 / 1024).toFixed(2)} MB
                      </p>

                      {/* Bouton pour changer de fichier */}
                      <div className="mt-4">
                        <button
                          onClick={() =>
                            document.getElementById("fichier").click()
                          }
                          type="button"
                          className="text-black text-sm font-medium underline"
                        >
                          Choisir un autre fichier
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between border-gray-100">
              {model && (
                <a
                  href={model}
                  download="modelFichier"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-900 text-white text-sm font-medium rounded-lg transition-colors duration-200"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  Télécharger le modèle
                </a>
              )}

              {/* Boutons d'action principales */}
              <div className="flex items-center gap-3 ml-auto">
                <button
                  onClick={handleUpload}
                  disabled={isSubmit || fichier.length === 0}
                  className={`
              inline-flex trunca items-center gap-2 px-6 py-2.5 rounded-lg font-medium text-sm transition-all duration-200
              ${
                isSubmit || fichier.length === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-main text-black shadow-sm hover:shadow-md"
              }
            `}
                >
                  {isSubmit ? (
                    <>
                      <svg
                        className="animate-spin w-4 h-4"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Chargement...
                    </>
                  ) : (
                    <>
                      <UploadIcon className="w-4 h-4" />
                      Charger le fichier
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};
